import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Chart} from 'chart.js';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {MatDialog} from '@angular/material/dialog';
import {Observable, Subscription} from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent} from '@angular/material/paginator';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-bar-chart-inactive-interventi',
  templateUrl: './bar-chart-inactive-interventi.component.html',
  styleUrls: ['./bar-chart-inactive-interventi.component.css']
})
export class BarChartInactiveInterventiComponent implements OnInit {

  
        // per inizializzazione
        getAuthState: Observable<any>;
        getDoctorState: Observable<any>;
        isAuthenticated: boolean;
        user = null;
        errorMessage = null;
        subscription1: Subscription;
        subscription2: Subscription;
        subscription3: Subscription;
        subscription5: Subscription;
        // elementi che servono per il bar-chart
        canvas: any;
        ctx: any;
        myChartInactivePatients: Chart;
        title = "Interventi";
        destination = 'inactive';
        // ******************************************************************************************************************
        
        // ******************************************************************************************************************
        // seguenti righe: inizializzazione dei pazienti 
        // ******************************************************************************************************************
        inactiveGlobalInterventi = 0;
        inactiveGlobalNoInterventi = 0;
        activeGlobalInterventi = 0;
        activeGlobalNoInterventi = 0;
        interventiGlobalPatients = 0;
        noInterventiGlobalPatients = 0;
        inactiveGlobalPatientsArray = [];
        activeGlobalPatientsArray = [];
        inactivePatientsGlobal = [];
        // ******************************************************************************************************************
        // bar chart dei pazienti 
        // ******************************************************************************************************************
        public barChartLabelsGlobalInactive = ['NO', 'SI'];
        public barChartTypeGlobalInactive = 'horizontalBar';
        public barChartLegendGlobalInactive = true;
        public barChartDataGlobalInactive = [
          {
            data: this.activeGlobalPatientsArray, label: 'Attivo', backgroundColor: ['teal', 'teal'],
            hoverBackgroundColor: ['#066', '#066'],maxBarPercentage : 0.5,  // number (pixels) or 'flex'
          },
          {
            data: this.inactiveGlobalPatientsArray, label: 'Inattivo', backgroundColor: ['orangered','orangered'],
            hoverBackgroundColor: ['#cc3700', '#cc3700'], maxBarPercentage: 0.5,  // number (pixels) or 'flex'
          }];
        // paginator Inactive
        public pageSizeInactive = 5;
        public currentPageInactive = 0;
        public tasksInactive: any[];
        public totalSizeInactive = 0;
        // selezione Inactive Patients Global
        selectedInactive = false;
        patientInactiveMail: string[] = [];
        checkedInactive = false;
        // hover variables of Inactive
        isActiveInactiveHovered = false;
        @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
          if (paginator) {
            paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
            paginator._intl.previousPageLabel = 'Pagina precedente';
            paginator._intl.nextPageLabel = 'Pagina successiva';
          }
        }
        // constructor
        constructor(private store: Store<AppState>,
                    private doctorService: DoctorService,
                    private snackBar: MatSnackBar) {
          this.getAuthState = this.store.select(selectAuthState);
          this.getDoctorState = this.store.select(selectDoctorState);
        }
        // ******************************************************************************************************************
        // metodo all'inizio
        ngOnInit(): void {
          this.subscription5 = this.getAuthState.subscribe((state) => {
            this.isAuthenticated = state.isAuthenticated;
            this.user = JSON.parse(localStorage.getItem('user'));
            this.errorMessage = state.errorMessage;
            this.retrieveGlobalInactiveNoInterventi();
          });
        }
        ngOnDestroy(): void {
          this.subscription1.unsubscribe();
          this.subscription2.unsubscribe();
          this.subscription3.unsubscribe();
          this.subscription5.unsubscribe();
        }
        // ******************************************************************************************************************
        // metodi che si richiamano in cascata e prendono tutti gli inattivi in telemedicina
        // e in standard e poi tutti
        // i pazienti in ogni categoria per poter calcolare gli attivi
        // retrieve global active and inactive patients (le funzioni si richiamano in cascata) bar chart
        retrieveGlobalInactiveNoInterventi() {
          this.subscription1 = this.doctorService.getInactiveNoInterventiNumber().subscribe(npatients => {
            console.log("inactive Nointerventi: "+npatients)
  
            this.inactiveGlobalNoInterventi = parseInt(npatients.toString());
            this.inactiveGlobalPatientsArray.push(this.inactiveGlobalNoInterventi); // riempio vettore del bar-chart con telemedicina
            this.retrieveGlobalInactiveInterventi();
          }, error => {
            if (error.status === 500) {
              localStorage.setItem('expirationTime', '0');
              console.log('SESSIONE SCADUTA');
              location.reload();
            }
          });
        }
        retrieveGlobalInactiveInterventi() {
          this.subscription2 = this.doctorService.getInactiveInterventiNumber().subscribe(npatients => {
            console.log("inactive Interventi: "+npatients)
            this.inactiveGlobalInterventi = parseInt(npatients.toString());
            this.inactiveGlobalPatientsArray.push(this.inactiveGlobalInterventi); // riempio il vettore del bar chart con standard
            this.retrieveGlobalInterventiNumber();
          }, error => {
            if (error.status === 500) {
              localStorage.setItem('expirationTime', '0');
              console.log('SESSIONE SCADUTA');
              location.reload();
            }
          });
        }
      
        retrieveGlobalInterventiNumber() {
          this.subscription3 = this.doctorService.getGlobalInterventiLoginExistsNumber().subscribe(num => {
            console.log(num);
            this.noInterventiGlobalPatients = num[0];
            this.interventiGlobalPatients = num[1];
            this.activeGlobalNoInterventi = this.noInterventiGlobalPatients - this.inactiveGlobalNoInterventi;
            this.activeGlobalPatientsArray.push(this.activeGlobalNoInterventi); // riempio il vettore del bar chart con telemedicina
            this.activeGlobalInterventi = this.interventiGlobalPatients - this.inactiveGlobalInterventi;
            this.activeGlobalPatientsArray.push(this.activeGlobalInterventi); // riempio il vettore del bar chart con standard
            this.canvasSetting();
          }, error => {
            if (error.status === 500) {
              localStorage.setItem('expirationTime', '0');
              console.log('SESSIONE SCADUTA');
              location.reload();
            }
          });
        }
       
        canvasSetting() {
            this.canvas = document.getElementById('myChartInactiveInterventi') as HTMLCanvasElement;
            this.ctx = this.canvas.getContext('2d');
            this.myChartInactivePatients = new Chart(this.ctx, {
              type: this.barChartTypeGlobalInactive,
              data: {
                labels: this.barChartLabelsGlobalInactive,
                datasets: this.barChartDataGlobalInactive,
              },
              options: {
                maintainAspectRatio: true,
                responsive: true,
                scales: {
                  xAxes: [{
                    display: true,
                    stacked: false,
                    ticks: {
                      fontSize: 12,
                      fontStyle: 'bold',
                      fontFamily: 'Helvetica',
                      fontColor: '#006192'
                    }
                  }],
                  yAxes: [{
                    display: true,
                    stacked: false,
                    ticks: {
                      fontSize: 12,
                      fontStyle: 'bold',
                      fontFamily: 'Helvetica',
                      fontColor: '#006192'
                    }
                  }],
                },
                legend: {
                  display: true,
                  position: 'top',
                  labels: {
                    usePointStyle: true,
                    fontColor: '#006192',
                    fontSize: 18,
                    fontFamily: 'Helvetica',
                  }
                },
                tooltips: {
                  // content: '{pathology}: {number}',
                  backgroundColor: '#1c1c1c',
                  bodyFontSize: 18,
                  titleFontSize: 18,
                  cornerRadius: 5,
                  caretPadding: 10
                },
                title: {
                  display: true,
                  text: "N° di utenti attivi/inattivi",
                  fontColor: '#006192',
                  fontSize: 20,
                  fontFamily: 'Helvetica',
                },
                hover: {
                  mode: 'nearest',
                  intersect: true
                }
              }
            });
            } // dopo aver ottenuto tutti i dati creo il bar chart
          }